import SideBar from '../sidebar';
import IRoute from '../../interfaces/route';

interface AuthenticatedLayoutProps {
    route: IRoute;
}

export function AuthenticatedLayout({ route }: AuthenticatedLayoutProps) {
    return (
        <div className='app-content'>
            {route.sidebar !== false && <SideBar />}
            <route.component name={route.name} {...route.props} />
        </div>
    );
}
